import { type ReactNode } from 'react';
import { View, type ViewProps } from 'react-native';
import { SafeAreaView, type Edge } from 'react-native-safe-area-context';

import { cn } from './cn';

export interface ScreenProps extends ViewProps {
  children: ReactNode;
  /** Safe-area edges to apply (default top + bottom). */
  edges?: readonly Edge[];
  className?: string;
}

/**
 * Full-screen warm-canvas container with safe-area handling.
 *
 * The background lives on a `react-native` `View` (which Uniwind swaps for its
 * theme-reactive component) rather than on `SafeAreaView` — Uniwind only wraps
 * components imported from `react-native`, so `react-native-safe-area-context`'s
 * `SafeAreaView` silently drops `className`, leaving the screen un-themed (white
 * in dark mode). The SafeAreaView sits on top purely to apply insets.
 */
export function Screen({
  children,
  edges = ['top', 'bottom'],
  className,
  ...props
}: ScreenProps) {
  return (
    <View className={cn('flex-1 bg-background', className)} {...props}>
      <SafeAreaView edges={edges} style={{ flex: 1 }}>
        {children}
      </SafeAreaView>
    </View>
  );
}
